import ApiModel from 'models/api-model';

export default class WorkpaperDetails extends ApiModel({
  data: {
    revisionId: null,
    elementId: null,
    workpaperRefId: null,
    referenceNumber: null,
    referenceName: null,
    workpaperRefCreatedBy: null,
    workpaperRefCreatedDate: null,
    elementWpRefCreatedBy: null,
    elementWpRefCreatedDate: null,
    elementCount: null,
    creationType: null,
    overrideCreationType: null,
    elementIds: null,
    workpaperType: null,
    new: null,
  },
}) {
  processResponse(response) {
    return { data: { ...response.data.result } };
  }

  get workpaperRefId() {
    return this.data.workpaperRefId;
  }

  get referenceNumber() {
    return this.data.referenceNumber;
  }

  get autoTieoutWPDetails() {
    return this.data;
  }
}
